import { render, staticRenderFns } from "./ResetButton.vue?vue&type=template&id=f7892528&scoped=true&"
import script from "./ResetButton.vue?vue&type=script&lang=js&"
export * from "./ResetButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7892528",
  null
  
)

export default component.exports